module.exports = __webpack_public_path__ + "img/vue-logo.9a45fc76.svg";